import React from "react";
import { Container } from "react-bootstrap";

const NotFound = () => {
  return (
    <Container>
      <h1>404 Not Found</h1>
    </Container>
  );
};

export default NotFound;
